/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { setToast } from '../../../store/ToastManagement';
import {
  Container,
  Grid,
  Segment,
  Header,
  Checkbox,
  Radio,
  Dropdown,
  Embed,
  Modal
} from 'semantic-ui-react';
import { Button } from 'formik-semantic-ui';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import {
  ConnectComponentsProvider,
  ConnectAccountOnboarding
} from '@stripe/react-connect-js';
import { useCurrentUser } from '../../../_services/hooks/user';
import {
  authAPI,
  servicesAPI,
  useCustomer,
  useCustomerPreferences
} from '../../../_services';
import { CardDetailsModal } from '../../../_components/users/';
import {
  AONLink,
  AONButton,
  AONCheckBox,
  AONRadioButtons,
  AONOnboardTask,
  AONTimeRange,
  AONNav
} from '../../../_components/layout/AON';
import { dbUTCDatetimeToLocalTime } from '../../../utils';
const qrcode = require('qrcode');

import '../customerDetail_styles.css';
import '../../../_components/layout/AON.css';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';

const Config = require('../../../conf');

const moment = extendMoment(Moment);

const EMAIL_TEMPLATE_SIGNUP_COMPLETED = 'd-baf572d6667f4764961358394575ac97';
const EMAIL_TEMPLATE_POSTCODE_REJECTED = 'd-f311d68be2f14943bbd009031edb154b';

const dayOptions = [
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5', value: 5 },
  { text: '6', value: 6 },
  { text: '7', value: 7 },
  { text: '8', value: 8 },
  { text: '9', value: 9 },
  { text: '10', value: 10 },
  { text: '11', value: 11 },
  { text: '12', value: 12 },
  { text: '13', value: 13 },
  { text: '14', value: 14 },
  { text: '15', value: 15 },
  { text: '16', value: 16 },
  { text: '17', value: 17 },
  { text: '18', value: 18 },
  { text: '19', value: 19 },
  { text: '20', value: 20 },
  { text: '21', value: 21 },
  { text: '22', value: 22 },
  { text: '23', value: 23 },
  { text: '24', value: 24 },
  { text: '25', value: 25 },
  { text: '26', value: 26 },
  { text: '27', value: 27 },
  { text: '28', value: 28 },
  { text: '29', value: 29 },
  { text: '30', value: 30 },
  { text: '31', value: 31 }
];

// AONTODO contractual terms should live in the database
const isBarnet50PoundsPerMonth = customerId => {
  return ['CCCR1eac3f5a-75ce-434b-b904-8bc62d7ede49', 'CCCR2dea5f26-e1b7-4f99-9ade-6cfbad95cfbe', 'CCCR543efdd8-ef37-4897-9a36-37e8f49c3bd0', 'CCCR950f9f22-234a-4cf3-a5c0-adf2c44a5957', 'CCCR30cc830e-b23c-4aed-b563-a34ed1bd2408', 'CCCR9e58ceb5-9e3f-4211-a6df-852261d4defc'].includes(customerId);
};
const isDoorSTEP = customerId => {
  return ['CCCR172c6c9a-0fe8-4699-bc4a-0c3092838c52', 'CCCR950f9f22-234a-4cf3-a5c0-adf2c44a5957', 'CCCRc37e61e5-96dc-4910-bec7-07228896edce', 'CCCR3ef5c6eb-4cda-47de-821c-93b270efadd3', 'CCCR9a294943-0152-4992-a447-22b4f661d6b3', 'CCCR8bd3a63e-7791-484f-8b7c-33fc77510438', 'CCCR34231394-ba5b-46d7-a3e0-d0377fcc7698', 'CCCR1aefcafe-55e9-44fe-bebb-0c710c9c40d8', 'CCCRf06eda33-5b1f-48f5-8e03-620b631c8701', 'CCCR73fde1c7-bf90-4a70-9b5c-9da05a268204', 'CCCR6fb101fa-a28e-4a8f-a797-16b223859cfc', 'CCCR14dc03e1-937b-4019-9603-9cb5a6ab93c5', 'CCCRa6953cb5-b336-492f-86ff-75f65d60d492', 'CCCR14e3db2a-f55c-4323-82fa-06150a093f88', 'CCCR03611cfb-5a36-4f9e-9c05-5def542145e2', 'CCCReb1237c0-9bc3-4acc-88eb-89967fdf4b14', 'CCCR86123fe1-072a-46cd-8f06-b4ebf3c1529e', 'CCCRa539bd23-e622-401a-9eeb-a762a861e35e', 'CCCRa9674f35-13fc-4606-bd95-700fd02991d3'].includes(customerId);
};
const isKapilPindoria = customerId => {
  return customerId === 'CCCRc37e61e5-96dc-4910-bec7-07228896edce';
};
const isGordonAttar = customerId => {
  return customerId === 'CCCR3ef5c6eb-4cda-47de-821c-93b270efadd3';    
};

const selfSurveyInitialPaymentDiscountPounds = 25;
const exitFee = 1000;
const homeMoveFee = 500;


const getPromotionCode = localAuthority => {
  // AONTODO move all promo codes into the database?
  const area = localAuthority.toUpperCase().replace(/[^a-z]/gi, '');
  return `AON${area}25`;
};

const chargingTypeOptions = [
  {
    name: 'Default',
    desc: 'Do not opt out of nationwide default',
    value: 'DEFAULT',
    enabled: true
  },
  {
    name: 'Trojan EcoSave',
    desc: 'By syncing with your energy tariff, we can start charging your vehicle when it is cheapest for you. If your electricity tariff has no cheaper period, this option defaults to Plug & Play.',
    value: 'ECO_SAVE',
    enabled: true
  },
  {
    name: 'Plug & Play',
    desc: 'Start charging as soon as you plug in.',
    value: 'PLUG_AND_PLAY',
    enabled: true
  },
  {
    name: 'Custom',
    desc: 'Set your own charging schedule.',
    value: 'CUSTOM',
    enabled: true
  }
];

const normalisePostcode = postcode => postcode.replace(/\s/g, '').toUpperCase();

const minutesToHoursMinsText = mins => {
  const hour = String(Math.floor(mins / 60)).padStart(2, '0');
  const minutes = String(mins % 60).padStart(2, '0');

  return hour + ':' + minutes;
};

const hourOptions = [...Array(48).keys()].map(idx => {
  return { text: minutesToHoursMinsText(idx * 30), value: idx * 30 };
});

const formatCurrencyAmount = (currency, amount) => {
  if (isNaN(amount)) return '...';

  // Convert balance to pounds
  // e.g. account.account.balance_whpence 130750 = £1.31
  const abs_amount_pence = Math.abs(amount);
  const abs_amount_pounds = Math.ceil(abs_amount_pence / 100);

  const dec = String(abs_amount_pounds).split('.')[1];
  return (
    (amount < 0 ? '-' : '') +
    currency +
    abs_amount_pounds.toFixed(dec && dec.length > 2 ? dec.length : 2)
  );
};

const getSignatureDate = timestamp => {
  if (!timestamp) return '';

  const bits = String(timestamp)
    .split('T')[0]
    .split('-');
  return bits[2] + '.' + bits[1] + '.' + bits[0];
};

const getSignatureTime = timestamp => {
  return timestamp ? dbUTCDatetimeToLocalTime(String(timestamp)) : '';
};

export const AONOnboard = ({ customerId }) => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const { currentUser } = useCurrentUser();
  const { customer } = useCustomer(customerId);
  const {
    customerPreferences,
    setCustomerPreferences
  } = useCustomerPreferences(customerId);

  const [init, setInit] = useState(true);
  const [initPostcode, setInitPostcode] = useState(true);
  const [account, setAccount] = useState(null);
  const [contract, setContract] = useState(null);
  const [aonHost, setAonHost] = useState(null);
  const [signUpState, setSignUpState] = useState(null);

  const [stage, setStage] = useState('0_LOADING');

  const [numSteps, setNumSteps] = useState(6);
  const [stepsCompleted, setStepsCompleted] = useState(null);

  const [surveyUrl, setSurveyUrl] = useState('');
  const [surveyQRCode, setSurveyQRCode] = useState('');

  const [showCardDetails, setShowCardDetails] = useState(false);
  const [showBankDetails, setShowBankDetails] = useState(false);

  const [tariffName, setTariffName] = useState('');
  const [tariffRate, setTariffRate] = useState('');

  const [contractEndDate, setContractEndDate] = useState('');

  const [understandGrantClaim, setUnderstandGrantClaim] = useState(false);
  const [agreeToPrivacyPolicy, setAgreeToPrivacyPolicy] = useState(false);
  const [agreeToEnterContract, setAgreeToEnterContract] = useState(false);
  const [acceptAndProceed, setAcceptAndProceed] = useState(false);
  const [acceptAndPayExtras, setAcceptAndPayExtras] = useState(false);

  const [weekdayChargingTimesValid, setWeekdayChargingTimesValid] = useState(false);
  const [weekendChargingTimesValid, setWeekendChargingTimesValid] = useState(false);

  const [confirmRequestSurveyOpen, setConfirmRequestSurveyOpen] = useState(false);

  const [connectToFlatpeak, setConnectToFlatpeak] = useState('');

  const [subscriptionDayOpen, setSubscriptionDayOpen] = useState(false);
  const [reimbursementDayOpen, setReimbursementDayOpen] = useState(false);

  const [hostingTypeOptions, setHostingTypeOptions] = useState([]);

  const [installationInvoice, setInstallationInvoice] = useState(null);

  const [initialPaymentJustPaid, setInitialPaymentJustPaid] = useState(false);

  // Ensure the Connect instance is only initialized once
  const [stripeConnectInstance] = useState(() => {
    const fetchClientSecret = async () => {
      return await servicesAPI
        .BillingServices('createStripeConnectAccountSession', customerId)
        .then(result => result.secret);
    };

    return loadConnectAndInitialize({
      publishableKey: Config.Local().stripePublicKey,
      fetchClientSecret: fetchClientSecret,
      appearance: {
        overlays: "dialog",
        variables: {
          colorPrimary: "#00205b",
        },
      },
    })
  });

  const dispatch = useDispatch();
  const displayMessage = (title, message, success) =>
    dispatch(
      setToast({
        title: title,
        success: success,
        body: message
      })
    );

  const customerName = customer ? customer.forename + ' ' + customer.surname : '';

  useEffect(() => {
    getSignUpState();

    // Refresh every 7 seconds
    const interval = setInterval(() => {
      if (stage !== '2_1_DASHBOARD') return;

      getSignUpState();
    }, 7000);
    return () => {
      clearInterval(interval);
    };
  }, [stage]);

  useEffect(() => {
    if (!customerId || !customer) return;

    servicesAPI.BillingServices('getAccountByCustomerId', customerId).then(account => setAccount(account));

    servicesAPI.AdminServices('getContract', customerId).then(contract => setContract(contract));

    // Get or create AON survey
    servicesAPI.AdminServices('getAonSurvey', customerId, null).then(survey => {
      const surveyUrl = Config.Local().portal_url + `/customer/aon_survey?id=${customerId}&auth=${survey.auth}`;

        setSurveyUrl(surveyUrl);
      getSurveyQRCode(surveyUrl);
    });

    // Get additional installation work invoice, if any
    const surveyId = `AONSurvey_${customerId}`;
    servicesAPI.AdminServices('listFiles', `aonSurveySLASH${surveyId}`).then(files => {
      files.forEach(f => {
        const mediaName = f.name.substring(f.name.lastIndexOf('/') + 1).split('.')[0];
        if (mediaName === 'InstallationInvoice') setInstallationInvoice(f);
      });
    });

    servicesAPI.CustomerServices('getAonHost', customerId).then(aonHost => setAonHost(aonHost));

    // If customer came from a mailshot about converting from HUB to Home, flag that their conversion is in progress
    if (customer.customer_conversion_status === 'EOI_NOTIFIED') {
      servicesAPI.CustomerServices('setConversionStatus', customerId, { new_conversion_status: 'EOI_INPROGRESS' });
    }
  }, [customerId, customer]);

  useEffect(() => {
    if (signUpState || !surveyUrl) return;

    getSignUpState();
  }, [signUpState, surveyUrl]);

  useEffect(() => {
    if (!signUpState) return;

    if (account) {
      if (syncAccount()) return;
    }

    let stepsCompleted = 0;

    // if (signUpState.agreed_to_terms) stepsCompleted++;
    if (signUpState.stripe_card_setup) stepsCompleted++;
    if (signUpState.flatpeak_id !== '') stepsCompleted++;
    if (signUpState.survey_completed || signUpState.self_survey === false || (signUpState.self_survey === true && signUpState.approved_for_aon === null)) stepsCompleted++;
    if (signUpState.hosting_type !== null) stepsCompleted++;
    if (signUpState.charging_type !== null) stepsCompleted++;
    if (signUpState.agreed_to_terms !== null) stepsCompleted++;

    setStepsCompleted(stepsCompleted);

    setWeekdayChargingTimesValid(
      signUpState.charging_type === 'CUSTOM' &&
      (signUpState.charging_times_weekday_2_start >= signUpState.charging_times_weekday_1_end) &&
      (
        signUpState.charging_times_weekday_2_start <= signUpState.charging_times_weekday_2_end ||
        signUpState.charging_times_weekday_2_start <= signUpState.charging_times_weekday_1_start
      )
    );
    setWeekendChargingTimesValid(
      signUpState.charging_type === 'CUSTOM' &&
      (signUpState.charging_times_weekend_2_start >= signUpState.charging_times_weekend_1_end) &&
      (
        signUpState.charging_times_weekend_2_start <= signUpState.charging_times_weekend_2_end ||
        signUpState.charging_times_weekend_2_start <= signUpState.charging_times_weekend_1_start
      )
    );

    setUnderstandGrantClaim(signUpState.agreed_to_terms);
    setAgreeToPrivacyPolicy(signUpState.agreed_to_terms);
    setAgreeToEnterContract(signUpState.agreed_to_terms);
  }, [signUpState]);

  useEffect(() => {
    if (
      !init ||
      !customer ||
      !customer.hasOwnProperty('agreed_to_terms_datetime') ||
      !account ||
      signUpState === null ||
      stepsCompleted === null
    )
      return;

    // If we have never checked if council has approved customer's postcode, or if they have
    // been rejected, check again (it may have changed since the last time they logged in)
    if (initPostcode && (signUpState.postcode_approved === null || !signUpState.postcode_approved_by_council)) {
      checkPostcodeApproval(customer.address_postcode);
      setInitPostcode(false);
      return;
    }

    setInit(false);

    if (signUpState.flatpeak_id !== '') getEnergyTariff();

    servicesAPI.AdminServices('getContract', customer.id).then(response => {
      setContractEndDate(getSignatureDate(response.end_datetime));
    });

    // Flag conversion status as in progress
    if (customer.customer_conversion_status === 'EOI_NOTIFIED') {
      servicesAPI.CustomerServices('setConversionStatus', customerId, { new_conversion_status: 'EOI_INPROGRESS' });      
    }

    // AONTODO this last minute requirement needs set up in API/database
    // First customer, Alon's postcode
    let hostingTypeOptions = [];

    if (isBarnet50PoundsPerMonth(customerId)) {
      // 21.07.2025 - early adopter Barnet customers have already been offered £50 so need to honour this
      hostingTypeOptions = [{
        name: '36 month Initial Term at £50 per month',
        desc: '',
        value: 0,
        enabled: true,
        initialTermMonths: 36,
        subscriptionFeePounds: 50,
        additionalAdaptorFeePounds: 10,
        promoCode: ''
      }];
    } else if (isDoorSTEP(customerId)) {
      // DoorSTEP customers offered 24 months at £25 per month
      hostingTypeOptions = [{
        name: '24 month Initial Term at £25 per month',
        desc: '',
        value: 0,
        enabled: true,
        initialTermMonths: 24,
        subscriptionFeePounds: 25,
        additionalAdaptorFeePounds: 10
      }];
    } else if (signUpState.postcode_approved_by_council) {
      if (signUpState.local_authority === 'Barnet') {
        // 21.07.2025 - Barnet want Trojan to pay them £10 per month, hence £60 instead of £50
        hostingTypeOptions = [{
          name: '36 month Initial Term at £60 per month',
          desc: '',
          value: 0,
          enabled: true,
          initialTermMonths: 36,
          subscriptionFeePounds: 60,
          additionalAdaptorFeePounds: 10
        }];
      } else {
        // All other districts/counties get standard offer
        hostingTypeOptions = [{
          name: '36 month Initial Term at £50 per month',
          desc: '',
          value: 0,
          enabled: true,
          initialTermMonths: 36,
          subscriptionFeePounds: 50,
          additionalAdaptorFeePounds: 10
        }];
      }
    // 30.06.2025 - council has not approved AON but offer terms anyway
    // This offer has been suspended so no offer is made to customers in councils that haven't approved AON
    } else {
      hostingTypeOptions = [{
        name: '36 month Initial Term at £50 per month',
        desc: '',
        value: 0,
        enabled: true,
        initialTermMonths: 36,
        subscriptionFeePounds: 50,
        additionalAdaptorFeePounds: 10
      }];
    }

    hostingTypeOptions.push({
      name: 'Pay-as-you-go and other subscription offers will be available after completing initial term',
      desc: '',
      value: hostingTypeOptions.length,
      enabled: false,
      initialTermMonths: 18,
      subscriptionFeePounds: 50,
      additionalAdaptorFeePounds: 10
    });

    setHostingTypeOptions(hostingTypeOptions);

    const expressionOfInterest = signUpState.postcode_approved_by_council === false;

    // Identify where customer is in the sign-up flow
    if (!signUpState.survey_completed) {
      setStage('2_0_SETUP');
    } else {
      if (expressionOfInterest)
        setStage('1_3_EXPRESSION_OF_INTEREST');
      else if (signUpState.approved_for_aon === true)
        setStage('2_1_DASHBOARD');
      else if (signUpState.approved_for_aon === false || signUpState.postcode_approved === false)
        setStage('4_2_REJECTED');
      else if (!signUpState.submitted_for_approval)
        setStage('2_1_DASHBOARD');
      else if ((signUpState.self_survey === false) || (signUpState.self_survey && signUpState.survey_completed))
        setStage('4_1_PROCESSING_APPLICATION');
      else
        setStage('2_1_DASHBOARD');
    }
  }, [init, initPostcode, customer, account, signUpState, stepsCompleted]);

  useEffect(() => {
    if (acceptAndProceed) cardInitialPayment(getInitialPaymentPounds());
  }, [acceptAndProceed]);

  useEffect(() => {
    if (acceptAndPayExtras) cardSupplementalPayment(signUpState.installation_supplemental_payment_pounds);
  }, [acceptAndPayExtras]);

  const isTrojanTesting = () => {
    return customer && (customer.email.includes('trojan.energy') || customer.email.includes('trojanenergyltd.com'));
  };

  const getSignUpState = () => {
    if (!surveyUrl) return;

    // Get or create signup flow state
    servicesAPI
      .AdminServices('getEntityState', 'AON_SIGN_UP', customerId)
      .then(state => {
        if (!state) {
          state = {
            postcode_approved: null,
            postcode_approved_by_council: null,
            local_authority: '',
            keep_details: null,

            hosting_type: null,
            initial_term_months: 0,
            subscription_fee_pounds: 0,
            additional_adaptor_fee_pounds: 0,
            installation_supplemental_payment_pounds: 0,

            charging_type: null,
            reimbursement_day: 1,
            subscription_day: 1,

            agreed_to_terms: null,
            stripe_card_setup: false,
            stripe_connect_setup: false,
            flatpeak_id: '',

            charging_times_weekday_1_start: 22 * 60,
            charging_times_weekday_1_end: 8 * 60,
            charging_times_weekday_2_start: 12 * 60,
            charging_times_weekday_2_end: 16 * 60,
            charging_times_weekend_1_start: 22 * 60,
            charging_times_weekend_1_end: 8 * 60,
            charging_times_weekend_2_start: 12 * 60,
            charging_times_weekend_2_end: 16 * 60,

            survey_url: surveyUrl,
            self_survey: null,
            survey_completed: false,

            submitted_for_approval: null,
            approved_for_aon: null,

            initial_payment_submitted: null,
            initial_payment_paid: null,
            installation_supplemental_payment_submitted: null,
            installation_supplemental_payment_paid: null
          };
        }

        // Sync supplemental payment via contract due to race condition where
        // customer can overwrite sign-up state after Civils team updates it
        if (contract?.installation_payment_amount && !state.installation_supplemental_payment_pounds) {
          state.installation_supplemental_payment_pounds = contract.installation_payment_amount;
          state.approved_for_aon = true;
          saveSignUpState(state);
        }
        setSignUpState(state);
      });
  };

  const saveSignUpState = newSignUpState => {
    servicesAPI.AdminServices('upsertEntityState', 'AON_SIGN_UP', customerId, newSignUpState);
  };

  const setAndSaveSignUpState = newSignUpState => {
    setSignUpState(newSignUpState);
    saveSignUpState(newSignUpState);
  };

  const checkPostcodeApproval = postcode => {
    servicesAPI
      .AdminServices('getLocalAuthorityPostcodeApproval', postcode)
      .then(response => {
        if (response.approved) {
          setAndSaveSignUpState({
            ...signUpState,
            local_authority: response.name,
            postcode_approved: true,
            postcode_approved_by_council: true
          });
          setWorkflowStep('ADDRESS_APPROVED');
        } else {
          // 30.06.2025 - open AON UK wide so postcodes are never rejected
          setAndSaveSignUpState({
            ...signUpState,
            local_authority: response.name,
            postcode_approved: true,
            postcode_approved_by_council: false
          });
          setWorkflowStep('ADDRESS_APPROVED');
          // setAndSaveSignUpState({
          //   ...signUpState,
          //   postcode_approved: false,
          //   approved_for_aon: false
          // });
          // setWorkflowStep('ADDRESS_REJECTED');
          // setWorkflowStep('AON_REJECTED');
        }

        if (!signUpState.survey_completed)
          setStage('2_0_SETUP');
        else
          setStage('2_1_DASHBOARD');
        // setStage(response.approved ? '1_1_POSTCODE_APPROVED' : '1_2_POSTCODE_NOT_APPROVED');
      });
  };

  const keepCustomerDetails = keep => {
    setAndSaveSignUpState({
      ...signUpState,
      keep_details: keep
    });
    setWorkflowStep(keep ? 'KEEP_DETAILS' : 'REMOVE_DETAILS');

    // Email customer
    servicesAPI.AdminServices('auditUserActivity', {
      entity_type: 'CUSTOMER',
      entity_id: customerId,
      activity: 'CustomerPostcodeRejected',
      notes: `HOME signup: Customer postcode rejected`,
      email_recipient: customer.email,
      email_template_id: EMAIL_TEMPLATE_POSTCODE_REJECTED,
      email_template_data: {}
    }, currentUser.id);

    setStage(keep ? '1_2_1_KEEP_DETAILS' : '1_2_2_REMOVE_DETAILS');
  };

  const getSurveyQRCode = url => {
    // Set colour to 00205b
    qrcode.toDataURL(url, (err, image) => {
      if (!err) setSurveyQRCode(image);
    });
  };

  const selfSurvey = () => {
    setAndSaveSignUpState({
      ...signUpState,
      self_survey: true
    });

    document.location.href = surveyUrl;
  };

  const requestTrojanSurvey = () => {
    const values = {
      customer_id: customerId
    };
    servicesAPI.AdminServices('requestSurvey', values);
  };

  const acceptTermsAndConditions = () => {
    // Audit
    const emailSubject = `HOME customer ${customerName} accepted T&Cs`;
    const emailBody = `HOME customer ${customerName} has accepted their legal terms and conditions`;

    const values = {
      audit: {
        user_id: currentUser.id,
        activity: 'CustomerContractSign',
        entity_type: 'CUSTOMER',
        entity_id: customer.id,
        notes: 'HOME signup: Accept legal terms',
        status: 'Completed',
        email_subject:  '', // emailSubject,
        email_body:  '' // emailBody
      }
    };

    const documentId = customer.terms_document_id;

    servicesAPI.CustomerServices('acceptTerms', values, customerId, documentId);
  };

  const createAonHostAndAccount = () => {
    if (aonHost) return;

    // Create AON host for customer
    let values = {
      customer_id: customerId,
      hydra_tag_id: '', // This gets assigned elsewhere
      status: 'ACTIVE',
      flatpeak_id: signUpState.flatpeak_id
    };
    servicesAPI.CustomerServices('createAonHost', customerId, values);

    // Don't create it twice
    servicesAPI.CustomerServices('getAonHost', customerId).then(aonHost => setAonHost(aonHost));

    // Create AON account
    values = {
      account_id: account.id,
      customer_id: customerId,
      customer_type: 'AONHOST',
      reimbursement_day_of_month: signUpState.reimbursement_day,
      payment_day_of_month: signUpState.subscription_day,
      monthly_fee: signUpState.subscription_fee_pounds * 100 * 1000 // Amount in Trojan units i.e. pence * 1000
    };
    servicesAPI.BillingServices('createAonAccount', values);
  };

  const syncEnergyTariff = () => {
    servicesAPI
      .MeteringServices('getFlatpeakBearerToken')
      .then(response => {
        const bearerToken = response.token;
        localStorage.setItem('flatpeakBeareroken', bearerToken);

        servicesAPI
          .MeteringServices('getFlatpeakConnectToken', bearerToken)
          .then(response => {
            const connectToken = response.token;
            localStorage.setItem('flatpeakConnectToken', connectToken);

            const url = `https://connect-web.flatpeak.com?fp_cot=${connectToken}`;

            setConnectToFlatpeak(url);
          });
      });
  };

  const getEnergyTariff = () => {
    const locationId = signUpState.flatpeak_id;

    servicesAPI
      .MeteringServices('getFlatpeakTariff', locationId)
      .then(tariff => {
        const rate = tariff.rate.toFixed(2);

        setTariffName(tariff.name);
        setTariffRate(`£${rate}`);
      });

    // servicesAPI
    //   .MeteringServices('getFlatpeakBearerToken')
    //   .then(response => {
    //     const bearerToken = response.token;
    //     localStorage.setItem('flatpeakBeareroken', bearerToken);
    //
    //     const locationId = signUpState.flatpeak_id;
    //
    //     servicesAPI
    //       .MeteringServices('getFlatpeakTariff', locationId)
    //       .then(tariff => {
    //         const rate = tariff.rate.toFixed(2);
    //
    //         setTariffName(tariff.name);
    //         setTariffRate(`£${rate}`);
    //       });
    //   });
  };

  const saveEnergyTariff = () => {
    const bearerToken = localStorage.getItem('flatpeakBeareroken');
    const connectToken = localStorage.getItem('flatpeakConnectToken');

    if (!bearerToken || !connectToken) return;

    servicesAPI
      .MeteringServices('getFlatpeakLocationId', bearerToken, connectToken)
      .then(location => {
        const locationId = location.location_id;

        setAndSaveSignUpState({
          ...signUpState,
          flatpeak_id: locationId
        });

        // Close Flatpeak iframe
        setConnectToFlatpeak('');

        servicesAPI
          .MeteringServices('getFlatpeakTariff', locationId)
          .then(tariff => {
            const rate = tariff.rate.toFixed(2);

            setTariffName(tariff.name);
            setTariffRate(`£${rate}`);

            setStage('2_4_SYNC_ENERGY_TARIFF');
          });

        servicesAPI.AdminServices('auditUserActivity', {
          entity_type: 'CUSTOMER',
          entity_id: customerId,
          activity: 'CustomerConnectFlatpeak',
          notes: `HOME signup: Connected to domestic energy tariff`,
          email_subject:  '',
          email_body:  ''
        }, currentUser.id);
      });
  };

  const syncAccount = () => {
    // Has a payment card been registered?
    if (account.card_last4_digits && signUpState.stripe_card_setup !== true) {
      setAndSaveSignUpState({
        ...signUpState,
        stripe_card_setup: true
      });

      servicesAPI.AdminServices('auditUserActivity', {
        entity_type: 'CUSTOMER',
        entity_id: customerId,
        activity: 'CustomerRegisterPaymentCard',
        notes: `HOME signup: Registered payment card via Stripe`,
        email_subject:  '',
        email_body:  ''
      }, currentUser.id);

      return true;
    }

    return false;
  };

  const startContract = () => {
    setAndSaveSignUpState({
      ...signUpState,
      submitted_for_approval: moment().format('YYYY-MM-DDTHH:mm:00') + ',Z',
      agreed_to_terms: moment().format('YYYY-MM-DDTHH:mm:00') + ',Z',
      initial_payment_submitted: true
    });

    acceptTermsAndConditions();
    if (signUpState.self_survey === false) requestTrojanSurvey();
    createAonHostAndAccount();

    servicesAPI.AdminServices('startContract', customerId);

    // setWorkflowStep(signUpState.self_survey ? 'MANUAL_SURVEY' : 'TROJAN_SURVEY'); // AONTODO Where to set this

    // setWorkflowStep('SURVEY_DETAILS_ADDED'); // AONTODO Where to set this

    // Update contract terms
    const values = {
      initial_payment_amount: getInitialPaymentPounds() * 100,
      installation_payment_amount: 0,
      minimum_term_months: signUpState.initial_term_months,
      monthly_payment_amount: signUpState.subscription_fee_pounds,
      additional_lance_monthly_payment_amount: signUpState.additional_adaptor_fee_pounds,
      monthly_payment_day: signUpState.subscription_day,
      monthly_reimbursement_day: signUpState.reimbursement_day,
      charging_credit: false
    };
    servicesAPI.AdminServices('updateContract', values, customerId);

    // Flag conversion status as submitted for approval
    servicesAPI.CustomerServices('setConversionStatus', customerId, { new_conversion_status: 'EOI_SUBMITTED' });
  };

  const getInitialPaymentPounds = () => {
    let initialPaymentPounds = signUpState.subscription_fee_pounds;

    // Apply discount for self-surveys
    if (signUpState.self_survey) initialPaymentPounds -= selfSurveyInitialPaymentDiscountPounds;

    // 30.06.2025 - for non-council approved sign-ups, initial payment is 0
    if (signUpState.postcode_approved_by_council === false || isDoorSTEP(customerId)) initialPaymentPounds = 0;

    return initialPaymentPounds;
  };

  const getExitFee = () => {
    // 31.10.2025 - Business waiving fee in order to secure sign-up
    if (isKapilPindoria(customerId)) return 0;
    return exitFee;
  };

  const getHomeMoveFee = () => {
    // 31.10.2025 - Business waiving fee in order to secure sign-up
    if (isKapilPindoria(customerId)) return 0;
    return homeMoveFee;
  };

  const needCardDetails = () => {
    // 30.06.2025 - non-Kent customers have £0 initial payment so don't need to supply card details
    return signUpState.postcode_approved_by_council;
  };

  const paymentCardRegisteredCallback = () => {
    console.log('TRJN_DBG: Payment card registered callback from Stripe');
    setShowCardDetails(false);

    syncAccount();

    // Refresh account to get card/bank details
    servicesAPI
      .BillingServices('getAccountByCustomerId', customerId)
      .then(account => setAccount(account));
  };

  const cardInitialPayment = amountPounds => {
    if (isTrojanTesting()) {
      if (amountPounds > 0) amountPounds = 1;
    }

    if (signUpState.initial_payment_submitted) return;

    // If nothing to pay, skip payment
    if (amountPounds === 0) {
      startContract();
      setInitialPaymentJustPaid(true);
      setStage('4_1_PROCESSING_APPLICATION');
      return;
    }

    const type = 'AonInitialPayment';
    const description = 'Trojan Energy HOME user initial payment';

    // Audit
    const name =
      customer.forename && customer.surname
        ? customer.forename + ' ' + customer.surname
        : '';

    const emailSubject = `HOME customer ${name} initial payment`;
    const emailBody = `New HOME customer ${name} has made their initial ${formatCurrencyAmount('£', amountPounds * 100)} payment.`;

    const notes = `${description} ${formatCurrencyAmount('£', amountPounds * 100)}`;

    const values = {
      transaction_type: type,
      account_id: account.id,
      amount_pence: amountPounds * 100,
      reason_str: description,
      promo_code: getPromotionCode(signUpState.local_authority)
    };

    servicesAPI
      .BillingServices('oneOffPayment', values)
      .then(response => {
        const transactionId = response.data;

        servicesAPI
          .BillingServices('processOneOffPayment', transactionId)
          .then(response => {
            startContract();

            // Send an automated email to aoninstalls?
            displayMessage('Success', `Initial Payment of £${amountPounds}${isTrojanTesting() ? '(£1 FOR THIS TEST)' : ''} has been taken!`, true);

            servicesAPI.AdminServices('auditUserActivity', {
              entity_type: 'CUSTOMER',
              entity_id: customerId,
              activity: 'BillingPayment',
              notes: notes,
              email_subject: '',
              email_body: ''
            }, currentUser.id);

            servicesAPI.AdminServices('sendMail', {
              email_recipient: 'aon.installs@trojan.energy',
              email_subject: 'HOME initial payment submitted',
              email_body: `<div>Customer ${customerName} has made initial payment.</div>`
            });

            setInitialPaymentJustPaid(true);
            setStage('4_1_PROCESSING_APPLICATION');
          });
      })
      .catch(response => {
        displayMessage(
          'Error',
          `A problem has occurred taking your Initial Payment of £${amountPounds}, please contact customer support on 0800 0854644`,
          false
        );

        setAndSaveSignUpState({
          ...signUpState,
          initial_payment_submitted: false
        });
      });
  };

  const cardSupplementalPayment = amountPounds => {
    if (isTrojanTesting()) amountPounds = 1;

    if (signUpState.installation_supplemental_payment_submitted) return;

    const type = 'AONInstallSupplement';
    const description = 'Trojan Energy HOME user installation supplement payment';

    // Audit
    const name =
      customer.forename && customer.surname
        ? customer.forename + ' ' + customer.surname
        : '';

    const emailSubject = `HOME customer ${name} installation supplement payment`;
    const emailBody = `New HOME customer ${name} has submitted their installation supplement ${formatCurrencyAmount('£', amountPounds * 100)} payment.`;

    const notes = `${description} ${formatCurrencyAmount('£', amountPounds * 100)}`;

    // Update contract terms
    let values = {
      initial_payment_amount: getInitialPaymentPounds() * 100,
      installation_payment_amount: amountPounds * 100,
      minimum_term_months: signUpState.initial_term_months,
      monthly_payment_amount: signUpState.subscription_fee_pounds,
      additional_lance_monthly_payment_amount: signUpState.additional_adaptor_fee_pounds,
      monthly_payment_day: signUpState.subscription_day,
      monthly_reimbursement_day: signUpState.reimbursement_day,
      charging_credit: false
    };
    servicesAPI.AdminServices('updateContract', customerId, values);

    values = {
      transaction_type: type,
      account_id: account.id,
      amount_pence: amountPounds * 100,
      reason_str: description
    };

    servicesAPI
      .BillingServices('oneOffPayment', values)
      .then(response => {
        setAndSaveSignUpState({
          ...signUpState,
          installation_supplemental_payment_submitted: true
        });
        displayMessage('Success', `Supplemental Payment of £${amountPounds}${isTrojanTesting() ? '(£1 FOR THIS TEST)' : ''} has been submitted and will be processed within 24 hours`, true);

        servicesAPI.AdminServices('auditUserActivity', {
          entity_type: 'CUSTOMER',
          entity_id: customerId,
          activity: 'BillingPayment',
          notes: notes,
          email_recipient: customer.email,
          email_template_id: EMAIL_TEMPLATE_SIGNUP_COMPLETED,
          email_template_data: {}
        }, currentUser.id);

        servicesAPI.AdminServices('sendMail', {
          email_recipient: 'aon.installs@trojan.energy',
          email_subject: 'HOME additional works payment submitted',
          email_body: `<div>Customer ${customerName} has submitted additional works payment.</div>`
        });

        servicesAPI.AdminServices('sendMail', {
          email_recipient: 'support@trojan.energy',
          email_subject: 'HOME signup complete',
          email_body: `<div>Customer ${customerName} has completed their HOME sign-up.</div>`
        });

        setStage('2_3_SURVEY_REVIEW_PAYMENT_THANK_YOU');
      })
      .catch(response => {
        displayMessage(
          'Error',
          `We're sorry, we weren't able to take your Supplemental Payment of £${amountPounds}`,
          false
        );

        setAndSaveSignUpState({
          ...signUpState,
          installation_supplemental_payment_submitted: false
        });
      });
  };

  const bankDetailsRegistered = () => {
    servicesAPI.BillingServices('onboardStripeAccount', customerId);

    servicesAPI.AdminServices('auditUserActivity', {
      entity_type: 'CUSTOMER',
      entity_id: customerId,
      activity: 'CustomerRegisterBankDetails',
      notes: `HOME signup: Registered bank details via Stripe`,
      mail_subject:  '',
      email_body:  ''
    }, currentUser.id);

    setAndSaveSignUpState({
      ...signUpState,
      stripe_connect_setup: true
    });

    // Refresh account to get card/bank details
    servicesAPI
      .BillingServices('getAccountByCustomerId', customerId)
      .then(account => setAccount(account));
  };

  const bankDetailsUpdated = () => {
    // AONTODO Audit this?
  };

  const canViewContract = () => {
    // Temporary hack to allow specific customer to view contract at any point in the sign-up process
    return isGordonAttar(customerId);
  };

  const canSignContract = () => {
    let numRequiredSteps = numSteps - 1;

    // 30.06.2025 - non-council-approved customers have £0 initial payment so don't need to supply card details
    if (!signUpState.postcode_approved_by_council)
      numRequiredSteps = numRequiredSteps - 1;

    return stepsCompleted >= numRequiredSteps;
  };

  const setHostingType = () => {
    saveSignUpState(signUpState);

    servicesAPI.AdminServices('auditUserActivity', {
      entity_type: 'CUSTOMER',
      entity_id: customerId,
      activity: 'CustomerSelectHostingType',
      notes: `HOME signup: Selected hosting type`,
      mail_subject: '', // `AON customer signup ${customerName}: selected hosting type`,
      email_body: '' //  `Potential AON customer ${customerName} has selected their hosting type`
    }, currentUser.id);
  };

  const setChargingType = () => {
    saveSignUpState(signUpState);

    // Default (EV smart charging regulations)
    let prefChargingType = 'Timed';
    let prefCheapestTariff = false;

    if (signUpState.charging_type === 'PLUG_AND_PLAY') {
      prefChargingType = 'Fastest';
      prefCheapestTariff = false;
    } else if (signUpState.charging_type === 'ECO_SAVE') {
      prefChargingType = 'Cheapest';
      prefCheapestTariff = true;
    } else if (signUpState.charging_type === 'CUSTOM') {
      prefChargingType = 'Timed';
      prefCheapestTariff = false;
    }

    setPreferences(
      'pref_charging_type', prefChargingType,
      'pref_cheapest_tariff', prefCheapestTariff,
      'pref_weekday_charging_times_1', minutesToHoursMinsText(signUpState.charging_times_weekday_1_start) + '-' + minutesToHoursMinsText(signUpState.charging_times_weekday_1_end),
      'pref_weekday_charging_times_2', minutesToHoursMinsText(signUpState.charging_times_weekday_2_start) + '-' + minutesToHoursMinsText(signUpState.charging_times_weekday_2_end),
      'pref_weekend_charging_times_1', minutesToHoursMinsText(signUpState.charging_times_weekend_1_start) + '-' + minutesToHoursMinsText(signUpState.charging_times_weekend_1_end),
      'pref_weekend_charging_times_2', minutesToHoursMinsText(signUpState.charging_times_weekend_2_start) + '-' + minutesToHoursMinsText(signUpState.charging_times_weekend_2_end)
    );

    servicesAPI.AdminServices('auditUserActivity', {
      entity_type: 'CUSTOMER',
      entity_id: customerId,
      activity: 'CustomerSelectChargingType',
      notes: `HOME signup: Selected charging type`,
      mail_subject: '', // `AON customer signup ${customerName}: selected charging type`,
      email_body: '' //  `Potential AON customer ${customerName} has selected their charging type`
    }, currentUser.id);
  };

  const setWorkflowStep = (step) => {
    return; // AONTODO remove this when DB table exists
    const values = {
      aon_approval_wf_step: step,
      wf_datetime: moment().format('YYYY-MM-DDTHH:mm:00'),
      wf_comment: '',
      actioned_by: 'customer'
    };
    servicesAPI.CustomerServices('upsertAonApprovalWorkflowStep', customer.id, values);
  };

  const setPreferences = (
    preference1, value1,
    preference2=null, value2=null,
    preference3=null, value3=null,
    preference4=null, value4=null,
    preference5=null, value5=null,
    preference6=null, value6=null
  ) => {
    let values = {
      ...customerPreferences,
      id: customerId
    };

    values[preference1] = value1;
    if (preference2) values[preference2] = value2;
    if (preference3) values[preference3] = value3;
    if (preference4) values[preference4] = value4;
    if (preference5) values[preference5] = value5;
    if (preference6) values[preference6] = value6;

    servicesAPI
      .CustomerServices(
        'updatePreferences',
        values,
        customerId
      )
      .then(response => setCustomerPreferences(values));
  };

  if (connectToFlatpeak) {
    return (
      <div>
        <div className="aon-modal"
          style={{ width: '100%', margin: '0 auto', maxWidth: '460px' }}
        >
          <span className="aon-buttons">
            <div className="safe-secure">
              <div className="safe-secure-sync2">Safe &amp; secure sync</div>
              <img className="safe-secure-logo2" src="/images/aon/safe-secure.svg" />
            </div>
            <img className="flatpeak-logo2" src="/images/aon/flatpeak.png" />
          </span>
        </div>
        <div>
          <Embed
            active={true}
            style={{ width: '100%', margin: '0 auto', maxWidth: '460px', minHeight: '900px' }}
            iframe={{
              id: 'iframe',
              allowFullScreen: true,
              style: {
                padding: 10,
              },
              src: connectToFlatpeak,
              onLoad: e => {
                saveEnergyTariff();
              }
            }}
            source={''}
          />
        </div>
      </div>
    );
  }

  return (
    <Container>
      <Grid centered padded>
        <Grid.Column style={{ maxWidth: 880 }}>
          {stage === '0_LOADING' && (
            <Container>
              <Grid centered padded>
                <Grid.Column style={{ maxWidth: 880 }}>
                  <Segment>
                    <div className="aon-modal">
                      <div className="aon-frame">
                        <div className="aon-text-box">
                          <span className="aon-text-box-span-bold">
                            Loading your details, please wait...
                            <br />
                          </span>
                        </div>
                      </div>
                    </div>
                  </Segment>
                </Grid.Column>
              </Grid>
            </Container>
          )}
          {stage === '1_1_POSTCODE_APPROVED' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Great news!</span>{' '}
                  <span className="aon-header-span-green"></span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span className="aon-text-box-span-bold">
                      We have an existing agreement with your council and can install in your area. Please continue with the signup process.
                      <br />
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Continue signing up'}
                    onClick={event => setStage('2_1_DASHBOARD')}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '1_2_POSTCODE_NOT_APPROVED' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Sorry we're not in your area yet.</span>{' '}
                  <span className="aon-header-span-green"></span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-bold">
                        We have yet to sign an agreement with your council to install in your area.
                        <br />
                      </span>
                      <span className="aon-text-box-span-light">
                        <br />
                        We are working with councils across the UK to bring Trojan Home to as many households as we can.<br /><br />Can we hold onto your information? It will only be used to contact you when we have brought this product to your area.
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Keep My Details'}
                    onClick={event => keepCustomerDetails(true)}
                  />
                  {' '}
                  <AONButton
                    active={true}
                    buttonText={'Remove My Details'}
                    onClick={event => keepCustomerDetails(false)}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '1_2_1_KEEP_DETAILS' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Thank you!</span>{' '}
                  <span className="aon-header-span-green"></span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-light">
                        We'll keep in touch.
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Exit.......'}
                    onClick={event => authAPI.logout()}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '1_2_2_REMOVE_DETAILS' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span>
                    <span className="aon-header-span-green">Your details have been removed</span>
                  </span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-light">
                        Thank you for your initial interest.
                        <br />
                        Please do stay in touch as we will hopefully be installing in your area soon.
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Exit.......'}
                    onClick={event => authAPI.logout()}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '1_3_EXPRESSION_OF_INTEREST' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span>
                    <span className="aon-header-span-green">Thanks for signing up for Trojan Home</span>
                  </span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-light">
                        We are currently in discussions with your council to install our charge points. At the moment they have asked us to only take expressions of interest before we move ahead with capturing full survey details.
                        <br />
                        <br />
                        We will give you an update on progress within 10 working days.
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Exit.......'}
                    onClick={event => authAPI.logout()}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '2_0_SETUP' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-frame2">
                  <div className="aon-header">
                    <span className="aon-header-span-green">Your Trojan Home Setup</span>
                  </div>
                  <div className="aon-text-box">
                    <span className="aon-text-box-span-bold3">
                      On-Street Charging at Home Energy Rates
                      <br />
                      <br />
                    </span>
                    <span className="aon-text-box-span-light">
                      We’ll need to gather a bit more information to help us proceed with installation.
                      <br />
                    </span>
                    <br />
                    <span className="aon-text-box-span-bold">
                      Let’s start with your property assessment survey.
                      <br />
                      <br />
                    </span>
                    <span className="aon-text-box-span-light">
                      This helps us confirm your home is suitable for installation, and takes about 10 minutes. You’ll need to do this on a phone with a camera.
                      <br />
                      <br />
                    </span>
                  </div>
                  <AONOnboardTask
                    name="Start Your Property Assessment Survey"
                    onboarded={false}
                    description={''}
                    completed={signUpState.survey_completed || signUpState.self_survey === false}
                    onClick={() => {
                      // if (currentUser?.impersonating) return;
                      setStage('2_3_SURVEY_SUBMISSION');
                    }}
                  />
                  <br />
                </div>
              </div>
            </Segment>
          )}
          {stage === '2_1_DASHBOARD' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-frame2">
                  <div className="aon-header">
                    <span className="aon-header-span-green">Trojan Home Dashboard</span>
                  </div>
                  <div
                    // className="aon-text-box-span-light"
                    className="aon-text-box"
                  >
                    {!signUpState.agreed_to_terms ? (
                      <>
                        Completing the additional steps below will help to speed up your ínstallation.
                        <br />
                        The steps can be completed in any order.
                        <br />
                        If you have any questions, please do get in touch on <a target="_blank" rel="noopener noreferrer" href="mailto:hello@trojan.energy">hello@trojan.energy</a>
                      </>
                    ) : (
                      <>
                        Thank you for completing the sign up to this point, your survey is in review and we expect to be back in touch within the next 10 working days.
                      </>
                    )}
                  </div>
                  <br />
                  <AONOnboardTask
                    name="Confirm Your Contract Length"
                    onboarded={signUpState.submitted_for_approval}
                    description={signUpState.hosting_type !== null ? hostingTypeOptions.find(o => (signUpState.hosting_type === o.value))?.name : ''}
                    completed={signUpState.hosting_type !== null}
                    onClick={() => {
                      if (currentUser?.impersonating) return;
                      if (signUpState.submitted_for_approval) return;

                      // Default to first option
                      if (signUpState.hosting_type === null && hostingTypeOptions.length) {
                        const ht = hostingTypeOptions[0];
                        setAndSaveSignUpState({
                          ...signUpState,
                          hosting_type: 0,
                          initial_term_months: ht.initialTermMonths,
                          subscription_fee_pounds: ht.subscriptionFeePounds,
                          additional_adaptor_fee_pounds: ht.additionalAdaptorFeePounds
                        });
                      }
                      setStage('2_1_HOSTING_TYPE');
                    }}
                  />
                  {!signUpState.approved_for_aon || (signUpState.postcode_approved_by_council === false && !signUpState.stripe_card_setup) ? (
                    <AONOnboardTask
                      name="Payments & Reimbursements"
                      onboarded={signUpState.submitted_for_approval}
                      description={signUpState.stripe_card_setup ? 'Card details assigned' : ''}
                      completed={signUpState.stripe_card_setup}
                      onClick={() => {
                        if (currentUser?.impersonating) return;
                        setShowCardDetails(false);
                        setShowBankDetails(false);
                        setStage('2_2_PAYMENTS_AND_REIMBURSEMENTS');
                      }}
                      enabled={needCardDetails()}
                    />
                  ) : (
                    <AONOnboardTask
                      name="Payments & Reimbursements"
                      onboarded={signUpState.approved_for_aon}
                      description={!signUpState.stripe_connect_setup ? 'Card details assigned (please connect your bank)' : 'Card and bank details assigned'}
                      completed={signUpState.stripe_card_setup && signUpState.stripe_connect_setup}
                      onClick={() => {
                        if (currentUser?.impersonating) return;
                        setShowCardDetails(false);
                        setShowBankDetails(false);
                        setStage('2_2_PAYMENTS_AND_REIMBURSEMENTS');
                      }}
                    />
                  )}
                  {!signUpState.submitted_for_approval ? (
                    <AONOnboardTask
                      name="Property Survey"
                      onboarded={false}
                      description={isDoorSTEP(customerId) ? 'n/a' : signUpState.survey_completed ? '(In review)' : signUpState.self_survey === false ? 'To be completed by Trojan' : ''}
                      completed={signUpState.survey_completed || signUpState.self_survey === false}
                      onClick={() => {
                        if (currentUser?.impersonating) return;
                        setStage('2_3_SURVEY_SUBMISSION');
                      }}
                    />
                  ) : (
                    <AONOnboardTask
                      name="Property Survey"
                      onboarded={true}
                      description={isDoorSTEP(customerId) ? 'n/a' : signUpState.approved_for_aon === null ? ((signUpState.self_survey === false && !signUpState.survey_completed) ? 'To be completed by Trojan' : 'In review') : 'Review is complete.' + signUpState.installation_supplemental_payment_pounds ? ' View Non-Standard Installation Supplement' : ''}
                      completed={signUpState.approved_for_aon !== null && signUpState.installation_supplemental_payment_submitted}
                      onClick={() => {
                        if (currentUser?.impersonating) return;
                        if (signUpState.approved_for_aon !== null) setStage('2_3_SURVEY_REVIEW');
                      }}
                    />
                  )}
                  <AONOnboardTask
                    name={signUpState.flatpeak_id === '' ? 'Sync your Energy tariff' : 'Synced Energy Tariff'}
                    onboarded={signUpState.submitted_for_approval}
                    description={tariffName}
                    completed={signUpState.flatpeak_id !== ''}
                    onClick={() => {
                      if (currentUser?.impersonating) return;
                      setStage('2_4_SYNC_ENERGY_TARIFF');
                    }}
                  />
                  <AONOnboardTask
                    name="Select Your Charging Preferences" status={signUpState.submitted_for_approval}
                    onboarded={signUpState.submitted_for_approval}
                    description={signUpState.charging_type ? chargingTypeOptions.find(o => (signUpState.charging_type === o.value)).name : ''}
                    completed={signUpState.charging_type !== null}
                    onClick={() => {
                      if (currentUser?.impersonating) return;
                      if (!signUpState.charging_type) {
                        setAndSaveSignUpState({
                          ...signUpState,
                          charging_type: 'DEFAULT'
                        });
                      }
                      setStage('2_5_CHARGING_PREFERENCES');
                    }}
                  />
                  <AONOnboardTask
                    name={(canViewContract() && !canSignContract()) ? 'Contract Summary' : !signUpState.agreed_to_terms ? 'Agree To Terms & Conditions' : 'Contract Summary'}
                    onboarded={signUpState.submitted_for_approval}
                    description={`Agreed to T&Cs on ${getSignatureDate(signUpState.agreed_to_terms)}`}
                    completed={signUpState.agreed_to_terms}
                    enabled={canViewContract() || canSignContract()}
                    onClick={() => {
                      if (currentUser?.impersonating) return;
                      setStage('3_CONTRACT_SUMMARY');
                    }}
                  />
                  {signUpState.postcode_approved_by_council === false ? (
                    <>
                      <br />
                      <div
                        // className="aon-text-box-span-light"
                        className="aon-text-box"
                      >
                        Once we have council approval for your installation, we will ask you to submit your payment details and select an installation date.
                      </div>
                    </>
                  ) : ''}
                  <br />
                  {/*<img className="aon-tick" src="/images/aon/tick.svg" />*/}
                  <div className="aon-text-box-span-light">
                    {stepsCompleted}/{numSteps} steps completed
                  </div>
                </div>
              </div>
            </Segment>
          )}
          {stage === '2_1_HOSTING_TYPE' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Confirm Your Contract Length</span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-light">
                        Based on your location the following contract lengths and associated Subscription Fees will be as set out below.
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <AONRadioButtons options={hostingTypeOptions} selected={signUpState.hosting_type} setSelected={value => {
                        const hostingType = hostingTypeOptions.find(ht => ht.value === value);
                        setAndSaveSignUpState({
                          ...signUpState,
                          hosting_type: value,
                          initial_term_months: hostingType.initialTermMonths,
                          subscription_fee_pounds: hostingType.subscriptionFeePounds,
                          additional_adaptor_fee_pounds: hostingType.additionalAdaptorFeePounds
                        });
                      }} />
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Back to Dashboard'}
                    onClick={event => {
                      setHostingType();
                      setStage('2_1_DASHBOARD');
                    }}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '2_2_PAYMENTS_AND_REIMBURSEMENTS' && (
            <Segment>
              <div className="aon-modal">
                <AONNav
                  onClick={event => {
                    setShowBankDetails(false);
                    setStage('2_1_DASHBOARD');
                  }}
                />
                {!signUpState.stripe_card_setup ? (
                  <>
                    <div className="aon-header">
                      <span className="aon-header-span-blue">Register</span>{' '}
                      <span className="aon-header-span-green">your payment card</span>
                    </div>
                    <br />
                    <span className="aon-buttons">
                      <AONButton
                        active={true}
                        buttonText={'Enter Card Details'}
                        onClick={event => setShowCardDetails(true)}
                      />
                      <div className="safe-secure">
                        <div className="safe-secure-sync">Safe &amp; secure sync</div>
                        <img className="safe-secure-logo" src="/images/aon/safe-secure.svg" />
                      </div>
                      <img className="stripe-logo" src="/images/aon/stripe.svg" />
                    </span>
                    {showCardDetails ? (
                      <CardDetailsModal
                        callback={paymentCardRegisteredCallback}
                        reload={true}
                        edit={true}
                        autoOpen={true}
                      />
                    ) : ''}
                    <br />
                    <br />
                    <br />
                  </>
                ) : (
                  <>
                    <div className="aon-header">
                      <span className="aon-header-span-blue">Card</span>{' '}
                      <span className="aon-header-span-green">Assigned</span>
                      <img className="aon-tick" src="/images/aon/tick.svg" />
                    </div>
                    <br />
                    <div className="aon-frame">
                      <div className="aon-text-box">
                        <span className="aon-text-box-span-light">
                          {account.card_name}
                        </span>
                      </div>
                    </div>
                    <br />
                    <div className="aon-frame">
                      <div className="aon-text-box">
                        <span className="aon-text-box-span-light">
                          Card Number **** **** **** {account.card_last4_digits}
                        </span>
                      </div>
                    </div>
                    <br />
                    <div className="aon-frame-flex-box">
                      <div className="aon-flex-box">
                        <span className="aon-flex-box-left-right aon-text-box-span-light">Select monthly billing date</span>
                        <span className="aon-flex-box-middle"></span>
                        <span className="aon-flex-box-left-right">
                          <Dropdown
                            selection
                            options={dayOptions}
                            onChange={(e, inputProps) => {
                              setAndSaveSignUpState({
                                ...signUpState,
                                subscription_day: inputProps.value
                              });
                            }}
                            value={signUpState.subscription_day}
                            upward={false}
                            onOpen={() => setSubscriptionDayOpen(true)}
                            onClose={() => setSubscriptionDayOpen(false)}
                          />
                          {/* HACK for Semantic UI bug displaying elements in front of dropdown */}
                          {subscriptionDayOpen ? (
                            <>
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                            </>
                          ) : (
                            ''
                          )}
                        </span>
                      </div>
                    </div>
                    <br />
                    <span className="aon-buttons">
                      <AONButton
                        active={true}
                        buttonText={'Edit Card'}
                        onClick={event => setShowCardDetails(true)}
                      />
                      <div className="safe-secure">
                        <div className="safe-secure-sync">Safe &amp; secure sync</div>
                        <img className="safe-secure-logo" src="/images/aon/safe-secure.svg" />
                      </div>
                      <img className="stripe-logo" src="/images/aon/stripe.svg" />
                    </span>
                    {showCardDetails ? (
                      <CardDetailsModal
                        callback={paymentCardRegisteredCallback}
                        reload={false}
                        edit={true}
                        autoOpen={true}
                      />
                    ) : ''}
                    <br />
                    <br />
                    <br />
                  </>
                )}
                {signUpState.approved_for_aon ?
                  !signUpState.stripe_connect_setup ? (
                    <>
                      <div className="aon-header">
                        <span className="aon-header-span-blue">Connect to </span>{' '}
                        <span className="aon-header-span-green">Your Bank</span>
                      </div>
                      <br />
                      <div className="aon-frame">
                        <div className="aon-text-box">
                          <span className="aon-text-box-span-light">
                            Add your details to start accepting money (reimbursements) from others that use the charger outside your home.
                          </span>
                        </div>
                      </div>
                      <br />
                      {showBankDetails ? (
                        <ConnectComponentsProvider
                          connectInstance={stripeConnectInstance}
                        >
                          <ConnectAccountOnboarding
                            // Optional: make sure to follow our policy instructions above
                            // fullTermsOfServiceUrl="{{URL}}"
                            // recipientTermsOfServiceUrl="{{URL}}"
                            // privacyPolicyUrl="{{URL}}"
                            // skipTermsOfServiceCollection={false}
                            collectionOptions={{
                              fields: 'eventually_due',
                              futureRequirements: 'include',
                            }}
                            onStepChange={(stepChange) => {
                              console.log(`User entered: ${stepChange.step}`);
                            }}
                            onExit={() => {
                              bankDetailsRegistered();
                            }}
                          />
                        </ConnectComponentsProvider>
                      ) : (
                        <span className="aon-buttons">
                          <AONButton
                            active={true}
                            buttonText={'Connect Bank'}
                            onClick={event => setShowBankDetails(true)}
                          />
                        </span>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="aon-header">
                        <span className="aon-header-span-blue">Bank Account</span>{' '}
                        <span className="aon-header-span-green">Connected</span>
                        <img className="aon-tick" src="/images/aon/tick.svg" />
                      </div>
                      <br />
                      <div className="aon-frame">
                        <div className="aon-text-box">
                          <span className="aon-text-box-span-light">
                            Account Number ****{account.account_last4_digits}
                          </span>
                        </div>
                      </div>
                      <br />
                      <div className="aon-frame">
                        <div className="aon-text-box">
                          <span className="aon-text-box-span-light">
                            Sort Code {account.account_sort_code}
                          </span>
                        </div>
                      </div>
                      <br />
                      <div className="aon-frame-flex-box">
                        <div className="aon-flex-box">
                          <span className="aon-flex-box-left-right aon-text-box-span-light">Select monthly reimbursement date</span>
                          <span className="aon-flex-box-middle"></span>
                          <span className="aon-flex-box-left-right">
                            <Dropdown
                              selection
                              options={dayOptions}
                              onChange={(e, inputProps) => {
                                setAndSaveSignUpState({
                                  ...signUpState,
                                  reimbursement_day: inputProps.value
                                });
                              }}
                              value={signUpState.reimbursement_day}
                              upward={false}
                              onOpen={() => setReimbursementDayOpen(true)}
                              onClose={() => setReimbursementDayOpen(false)}
                            />
                            {/* HACK for Semantic UI bug displaying elements in front of dropdown */}
                            {reimbursementDayOpen ? (
                              <>
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                              </>
                            ) : (
                              ''
                            )}
                          </span>
                        </div>
                      </div>
                      <br />
                      {showBankDetails ? (
                        <ConnectComponentsProvider
                          connectInstance={stripeConnectInstance}
                        >
                          <ConnectAccountOnboarding
                            // Optional: make sure to follow our policy instructions above
                            // fullTermsOfServiceUrl="{{URL}}"
                            // recipientTermsOfServiceUrl="{{URL}}"
                            // privacyPolicyUrl="{{URL}}"
                            // skipTermsOfServiceCollection={false}
                            collectionOptions={{
                              fields: 'eventually_due',
                              futureRequirements: 'include',
                            }}
                            onStepChange={(stepChange) => {
                              console.log(`User entered: ${stepChange.step}`);
                            }}
                            onExit={() => {
                              bankDetailsUpdated();
                            }}
                          />
                        </ConnectComponentsProvider>
                      ) : (
                        <span className="aon-buttons">
                          <AONButton
                            active={true}
                            buttonText={'Edit Bank'}
                            onClick={event => setShowBankDetails(true)}
                          />
                          <div className="safe-secure">
                            <div className="safe-secure-sync">Safe &amp; secure sync</div>
                            <img className="safe-secure-logo" src="/images/aon/safe-secure.svg" />
                          </div>
                          <img className="stripe-logo" src="/images/aon/stripe.svg" />
                        </span>
                      )}
                      <br />
                      <span className="aon-buttons">
                        <AONButton
                          active={true}
                          buttonText={'Back to Dashboard'}
                          onClick={event => setStage('2_1_DASHBOARD')}
                        />
                      </span>
                    </>
                  )
                : ''}
              </div>
            </Segment>
          )}
          {stage === '2_3_SURVEY_SUBMISSION' && (
            <Segment>
              <div className="aon-modal">
                {signUpState.survey_completed ? (
                  <>
                    <div className="aon-header">
                      <span className="aon-header-span-blue">Your Survey is being reviewed</span>
                    </div>
                    <br />
                    <div className="aon-frame">
                      <div className="aon-text-box">
                        <span className="aon-text-box-span-light">
                          Thank you for completing the survey! We will be in touch to arrange any installation requirements.
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="aon-header">
                      <span className="aon-header-span-blue">Start Property Assessment Survey</span>
                    </div>
                    <br />
                    <div className="aon-frame">
                      <div className="aon-text-box">
                        <span className="aon-text-box-span-light">
                          We will need to survey your property to support our  team in installing your home-connected charge point. 
                          <br />
                          <br />
                          If you are able to do this on our behalf by uploading pictures and videos, it will accelerate your installation (and to say thanks we'll give you £{selfSurveyInitialPaymentDiscountPounds} off your first month’s subscription)
                          <br />
                          <br />
                          The process will take approximately 10mins, and the information gathered gives our team the information required to plan your installation.
                        </span>
                      </div>
                    </div>
                    <br />
                    <div className="aon-frame">
                      <div className="aon-text-box">
                        <span>
                          <span className="aon-text-box-span-light">
                            You’ll need to upload photos and videos in order to carry out this self survey. This is usually easiest on a mobile phone.
                          </span>
                          <span className="aon-text-box-span-bold">
                            <br />
                            <br />
                            Scan the QR code below with a smartphone to get started, or:
                          </span>
                        </span>
                      </div>
                      <br />
                      <div style={{ width: '160px' }}>
                        <AONButton
                          active={true}
                          buttonText={'Start survey'}
                          onClick={event => selfSurvey()}
                        />
                      </div>
                      <div className="aon-text-box">
                        <span>
                          <span className="aon-text-box-span-light">
                            <br />
                            If you would like help with your survey, please contact our customer services team on 0800 0854 644 or hello@trojan.energy
                          </span>
                        </span>
                        <span>
                          <span className="aon-text-box-span-light">
                            {surveyQRCode ? <img src={surveyQRCode} width="200" height="200" alt="QR" /> : ''}
                          </span>
                        </span>
                      </div>
                    </div>
                  </>
                )}
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Back to Dashboard'}
                    onClick={event => setStage('2_1_DASHBOARD')}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '2_3_SURVEY_REVIEW' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-modal">
                  <AONNav onClick={event => setStage('2_1_DASHBOARD')} />
                  <div className="aon-header">
                    <span className="aon-header-span-blue">Survey</span>{' '}
                    <span className="aon-header-span-green">Review</span>
                  </div>
                  <br />
                  <div className="aon-frame">
                    <div className="aon-text-box">
                      <span className="aon-text-box-span-light">
                        Your survey has been reviewed and accepted!
                        <br />
                        {!signUpState.installation_supplemental_payment_submitted ? (
                          <>
                            <br />
                            Due to the nature of the install at your property, we have identified Non-Standard Installation Supplements that require your attention.
                            <br />
                            <br />
                            <span className="aon-text-box-span-bold">Please review and accept these items before you proceed.</span>
                          </>
                        ) : ''}
                        <br />
                        <br />
                        {installationInvoice ? ( <iframe src={installationInvoice.url} width="100%" height="800px"></iframe> ) : ''}
                      </span>
                    </div>
                  </div>
                  <br />
                  <span className="aon-buttons">
                    <AONButton
                      active={true}
                      buttonText={'Next.....'}
                      onClick={event => {
                        if (!signUpState.installation_supplemental_payment_submitted)
                          setStage('2_3_SURVEY_REVIEW_PAYMENT');
                        else
                          setStage('2_3_SURVEY_REVIEW_THANK_YOU');
                      }}
                    />
                  </span>
                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </Segment>
          )}
          {stage === '2_3_SURVEY_REVIEW_PAYMENT' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Nearly there!</span>{' '}
                  <span className="aon-header-span-green"></span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span className="aon-text-box-span-light">
                      A total of <span className="aon-text-box-span-bold">£{signUpState.installation_supplemental_payment_pounds}.00</span>{isTrojanTesting() ? <b>(£1 FOR THIS TEST)</b> : ''} will be debited from your assigned card.
                      <br />
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Accept & Pay Extras'}
                    onClick={event => {
                      if (!acceptAndPayExtras) setAcceptAndPayExtras(true); // Debounce payment button
                    }}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '2_3_SURVEY_REVIEW_PAYMENT_THANK_YOU' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Thank you!</span>{' '}
                  <span className="aon-header-span-green"></span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span className="aon-text-box-span-light">
                      {signUpState.installation_supplemental_payment_pounds ? 'Your account has been successfully debited. ' : ''}
                      We will shortly be in touch to arrange an installation date with you.
                      <br />
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Back to Dashboard'}
                    onClick={event => {
                      setStage('2_1_DASHBOARD');
                    }}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '2_3_SURVEY_REVIEW_THANK_YOU' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Thank you!</span>{' '}
                  <span className="aon-header-span-green"></span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span className="aon-text-box-span-light">
                      We will shortly be in touch to arrange an installation date with you.
                      <br />
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Back to Dashboard'}
                    onClick={event => {
                      setStage('2_1_DASHBOARD');
                    }}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '2_3_1_REQUESTED_TROJAN_SURVEY' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Survey Requested!</span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span className="aon-text-box-span-light">
                      Your survey has been requested. We will be in touch to arrange a suitable time.
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Back to Dashboard'}
                    onClick={event => setStage('2_1_DASHBOARD')}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '2_4_SYNC_ENERGY_TARIFF' && (
            signUpState.flatpeak_id === '' ? (
              <Segment>
                <div className="aon-modal">
                  <AONNav onClick={event => setStage('2_1_DASHBOARD')} />
                  <div className="aon-header">
                    <span className="aon-header-span-blue">Sync</span>{' '}
                    <span className="aon-header-span-green">your Energy tariff</span>
                  </div>
                  <br />
                  <div className="aon-frame">
                    <div className="aon-text-box">
                      <span>
                        <span className="aon-text-box-span-light">
                          When the charger connected to your house is used by someone else, we will reimburse you. In order to do so, we will need:
                        </span>
                        <span className="aon-text-box-span-light">
                          <br />
                          <ul>
                            <li>
                              Read-only access to your online account with your energy supplier (to see how much energy was used)
                            </li>
                            <li>
                              Details for repayment {signUpState.postcode_approved_by_council === false ? '(Will be requested after installation is approved)' : ''}
                            </li>
                          </ul>
                        </span>
                        <span className="aon-text-box-span-bold">
                          Please have your log in details for your energy supplier ready.
                          <br />
                        </span>
                      </span>
                    </div>
                  </div>
                  <br />
                  <span className="aon-buttons">
                    <AONButton
                      active={true}
                      buttonText={'Sync Your Tariff'}
                      onClick={event => syncEnergyTariff()}
                    />
                    <div className="safe-secure">
                      <div className="safe-secure-sync">Safe &amp; secure sync</div>
                      <img className="safe-secure-logo" src="/images/aon/safe-secure.svg" />
                    </div>
                    <img className="flatpeak-logo" src="/images/aon/flatpeak.png" />
                  </span>
                </div>
              </Segment>
            ) : (
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Sync</span>{' '}
                  <span className="aon-header-span-green">complete</span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-light">
                        We are now able to access your tariff data, you're on a {tariffName} tariff and you're currently paying {tariffRate}/kWh + VAT for your electricity, but don’t worry we’ll check it every time someone charges to make sure you're reimbursed accurately every time.
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Back to Dashboard'}
                    onClick={event => {
                      const search = new URLSearchParams(location.search);
                      search.delete('tariffsync');
                      history.replace({ ...location, search: search.toString() });

                      setStage('2_1_DASHBOARD');
                    }}
                  />
                </span>
              </div>
            )
          )}
          {stage === '2_5_CHARGING_PREFERENCES' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Select your charging preferences</span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-light">
                        The nationwide default, mandated by the UK government, is that no charging takes place between 8am and 11am or between 4pm and 10pm on Monday to Friday. You can opt out of this default and select a charging type that suits you by choosing one of the three alternatives below:
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-bold">
                        Select Charging Type
                      </span>
                      <br />
                      <AONRadioButtons options={chargingTypeOptions} selected={signUpState.charging_type} setSelected={value => {
                        setAndSaveSignUpState({
                          ...signUpState,
                          charging_type: value
                        });
                      }} />
                    </span>
                  </div>
                </div>
                {signUpState.charging_type === 'CUSTOM' ? (
                  <>
                    <div className="aon-frame-flex-box" style={{ overflow: 'initial' }}>
                      <AONTimeRange
                        name="Weekday charge period 1"
                        options={hourOptions}
                        lowValue={signUpState.charging_times_weekday_1_start}
                        setLowValue={value => {
                          setAndSaveSignUpState({
                            ...signUpState,
                            charging_times_weekday_1_start: value
                          });
                        }}
                        highValue={signUpState.charging_times_weekday_1_end}
                        setHighValue={value => {
                          setAndSaveSignUpState({
                            ...signUpState,
                            charging_times_weekday_1_end: value
                          });
                        }}
                      />
                      <br />
                      <AONTimeRange
                        name="Weekday charge period 2"
                        options={hourOptions}
                        lowValue={signUpState.charging_times_weekday_2_start}
                        setLowValue={value => {
                          setAndSaveSignUpState({
                            ...signUpState,
                            charging_times_weekday_2_start: value
                          });
                        }}
                        highValue={signUpState.charging_times_weekday_2_end}
                        setHighValue={value => {
                          setAndSaveSignUpState({
                            ...signUpState,
                            charging_times_weekday_2_end: value
                          });
                        }}
                      />
                      {!weekdayChargingTimesValid ? (
                        <div style={{ color: 'red' }}>
                          Weekday periods cannot overlap
                          <br />
                        </div>
                      ) : (
                        ''
                      )}
                      <br />
                      <AONTimeRange
                        name="Weekend charge period 1"
                        options={hourOptions}
                        lowValue={signUpState.charging_times_weekend_1_start}
                        setLowValue={value => {
                          setAndSaveSignUpState({
                            ...signUpState,
                            charging_times_weekend_1_start: value
                          });
                        }}
                        highValue={signUpState.charging_times_weekend_1_end}
                        setHighValue={value => {
                          setAndSaveSignUpState({
                            ...signUpState,
                            charging_times_weekend_1_end: value
                          });
                        }}
                      />
                      <br />
                      <AONTimeRange
                        name="Weekend charge period 2"
                        options={hourOptions}
                        lowValue={signUpState.charging_times_weekend_2_start}
                        setLowValue={value => {
                          setAndSaveSignUpState({
                            ...signUpState,
                            charging_times_weekend_2_start: value
                          });
                        }}
                        highValue={signUpState.charging_times_weekend_2_end}
                        setHighValue={value => {
                          setAndSaveSignUpState({
                            ...signUpState,
                            charging_times_weekend_2_end: value
                          });
                        }}
                      />
                      {!weekendChargingTimesValid ? (
                        <div style={{ color: 'red' }}>
                          Weekend periods cannot overlap
                          <br />
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </>
                ) : ''}
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-light">
                        You’ll be able to update your charging preference at any time.
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={signUpState.charging_type !== 'CUSTOM' || (weekdayChargingTimesValid && weekendChargingTimesValid)}
                    buttonText={'Submit'}
                    onClick={event => {
                      setStage('2_1_DASHBOARD');
                      setChargingType();
                    }}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '3_CONTRACT_SUMMARY' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Your Contract Summary</span>{' '}
                  <span className="aon-header-span-green"></span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-light">
                        Your Trojan Energy Contract is governed by the Trojan Energy EV Charging Terms of Service (the <span className="aon-text-box-span-bold">Terms of Service</span>) and the Trojan Home Host Terms and Conditions for Subscribers (the <span className="aon-text-box-span-bold">Trojan Home Terms</span>), each available at https://trojan.energy/terms (the <span className="aon-text-box-span-bold">Governing Terms</span>). Please read the Governing Terms and this Contract Summary carefully.
                      </span>
                      <br />

                      <br />
                      <span className="aon-text-box-span-bold">
                        Your Contract details
                      </span>
                      <br />
                      <br />
                      <span className="aon-text-box-span-light">
                        Initial Term: <span className="aon-text-box-span-bold">{signUpState.initial_term_months} months</span>
                        <br />
                        Connection Period: <span className="aon-text-box-span-bold">5 years</span>
                        <br />
                        Subscription Fee: <span className="aon-text-box-span-bold">£{signUpState.subscription_fee_pounds} per month</span>
                        <br />
                        Initial Payment: <span className="aon-text-box-span-bold">£{getInitialPaymentPounds()} {isTrojanTesting() ? <b>(£1 FOR THIS TEST)</b> : ''}</span>
                        <br />
                        Additional Adaptor Fee:	<span className="aon-text-box-span-bold">Optional £{signUpState.additional_adaptor_fee_pounds} per month as an addition to your Subscription Fee</span>
                      </span>
                      <br />
                      <br />
                      <span className="aon-text-box-span-bold">
                        Key terms
                      </span>
                      <br />
                      <br />
                      <span className="aon-text-box-span-light">
                        By agreeing and entering into this Contract, we will provide or supply to you or for your use:
                        <br />
                        <br />
                        <ul>
                          <li>
                            • the Trojan Home Equipment for installation at your Property and connection to your domestic energy supply;
                          </li>
                          <li>
                            • one Trojan Adaptor to allow you to connect your electric vehicle to the Trojan Home Charge Point;
                          </li>
                          <li>
                            • up to one Additional Adaptor for use by another member of your household, subject to the Additional Adaptor Fee set out in your contract details above; and,
                          </li>
                          <li>
                            • access to the Services to allow you to charge your electric vehicle either using the Trojan Home Charge Point or any other charge point in the Trojan Charging Network.
                          </li>
                        </ul>
                        <br />
                        As a Host, you acknowledge that:
                        <br />
                        <br />
                        <ul>
                          <li>
                            • by payment of the Subscription Fee, you may make use of the Trojan Home Charge Point and pay only your Domestic Tariff for energy used for your charging;
                          </li>
                          <li>
                            • the Trojan Home Charge Point is not for your exclusive use and must be Shared with other local residents;
                          </li>
                          <li>
                            • all use of the Trojan Home Charge Point by a Secondary User will be accurately measured and you will be Reimbursed at your Domestic Tariff such that you will not be out of pocket; and,
                          </li>
                          <li>
                            • the installation of an Trojan Home Charge Point at your Property does not provide you with any right to park which will be subject to any existing local parking regulations.
                          </li>
                        </ul>
                      </span>
                      <br />
                      <span className="aon-text-box-span-bold">
                        Additional charges
                      </span>
                      <br />
                      <br />
                      <span className="aon-text-box-span-light">
                        <ul>
                          <li>
                            The <span className="aon-text-box-span-bold">Compensation Rate</span> payable by Trojan Energy to you is £2 per full day of lost service, capped at your Subscription Fee in any billing month.
                          </li>
                          <li>
                            If you are required to pay an <span className="aon-text-box-span-bold">Early Termination Fee</span>, the charge will be a sum equal to your Subscription Fee multiplied by the remaining number of months of the Initial Term.
                          </li>
                          <li>
                            If you are required to pay an <span className="aon-text-box-span-bold">Exit Fee</span>, the charge will be £{getExitFee(customerId)}.
                          </li>
                          <li>
                            If you are required to pay a <span className="aon-text-box-span-bold">Home Move Fee</span>, the charge will be £{getHomeMoveFee(customerId)}.
                          </li>
                        </ul>
                      </span>
                      <br />
                      <br />
                      <span className="aon-text-box-span-bold">
                        Before we install your charger:
                      </span>
                      <br />
                      <span className="aon-text-box-span-light">
                        <ul>
                          <li>
                            You’ll need to claim the cross-pavement OZEV grant on Trojan Energy’s behalf. It only takes about 10 minutes.
                          </li>
                        </ul>
                      </span>
                      <br />
                      <span className="aon-text-box-span-bold">
                        Here’s how it works:
                      </span>
                      <br />
                      <span className="aon-text-box-span-light">
                        <ul>
                          <li>
                            • Your council will send Trojan Energy the approval documentation we need for your installation.
                          </li>
                          <li>
                            • Around 1–2 weeks before your installation, we’ll email you step-by-step instructions to complete your grant application.
                          </li>
                        </ul>
                      </span>
                      <br />
                      <span className="aon-text-box-span-bold">
                        Why it matters:
                      </span>
                      <br />
                      <span className="aon-text-box-span-light">
                        <ul>
                          <li>
                            • Claiming the grant means we're able to offer you a £50/month subscription.
                          </li>
                          <li>
                            • If you don’t claim, you’ll be charged the full £350 grant value.
                          </li>
                        </ul>
                      </span>
                      <br />
                      <span className="aon-text-box-span-bold">
                        The grant is yours to claim - why waste it?
                      </span>
                      <br />
                      <span className="aon-text-box-span-light">
                        <ul>
                          <li>
                            • Claiming the grant means we're able to offer you a £50/month subscription.
                          </li>
                          <li>
                            • If you don’t claim, you’ll be charged the full £350 grant value.
                          </li>
                        </ul>
                      </span>
                      <br />
                      <br />
                      <span
                        className="aon-container"
                        onClick={event => {
                          window.open('https://trojan.energy/content/uploads/2025/08/Trojan-Home-Host-Terms-Conditions-for-Subscribers-Rev04-August-2025-compressed.pdf', '_blank');
                        }}
                      >
                        <p className="aon-dark-button">
                          Trojan Home Host Terms and Conditions for Subscribers
                        </p>
                        <img className="aon-icon-left" src="/images/aon/icon-left.svg" />
                      </span>
                      <br />
                      <span
                        className="aon-container"
                        onClick={event => {
                          window.open('https://trojan.energy/content/uploads/2025/05/Trojan-Energy-EV-Charging-Terms-of-Service-Rev03-May-2025.pdf', '_blank');
                        }}
                      >
                        <p className="aon-dark-button">
                          Trojan Energy EV Charging Terms of Service
                        </p>
                        <img className="aon-icon-left" src="/images/aon/icon-left.svg" />
                      </span>
                      <br />
                      <span
                        className="aon-container"
                        onClick={event => {
                          window.open('https://trojan.energy/content/uploads/2025/01/IT-P-004-Privacy-Notice-for-Website-Visitors-Users-of-EV-Charging-Services-Rev02-January-2025.pdf', '_blank');
                        }}
                      >
                        <p className="aon-dark-button">
                          Trojan Energy Privacy Policy
                        </p>
                        <img className="aon-icon-left" src="/images/aon/icon-left.svg" />
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <br />
                <span className="aon-checkbox">
                  <Checkbox
                    className="aon-checkbox-box"
                    checked={understandGrantClaim}
                    onChange={(e, data) => setUnderstandGrantClaim(!understandGrantClaim)}
                    disabled={!canSignContract() || understandGrantClaim}
                  />
                  <p className="aon-checkbox-text">
                    By ticking this box, I understand that when I receive Trojan Energy’s email with instructions, I’ll need to complete the cross-pavement OZEV grant application. If I don’t claim the grant, I’ll be charged £350 - so I might as well claim it, it’s mine!
                  </p>
                </span>
                <br />
                <span className="aon-checkbox">
                  <Checkbox
                    className="aon-checkbox-box"
                    checked={agreeToPrivacyPolicy}
                    onChange={(e, data) => setAgreeToPrivacyPolicy(!agreeToPrivacyPolicy)}
                    disabled={!canSignContract() || agreeToPrivacyPolicy}
                  />
                  <p className="aon-checkbox-text">
                    I agree to the Governing Terms and to the Trojan Energy Privacy Policy
                  </p>
                </span>
                <br />
                <span className="aon-checkbox">
                  <Checkbox
                    className="aon-checkbox-box"
                    checked={agreeToEnterContract}
                    onChange={(e, data) => setAgreeToEnterContract(!agreeToEnterContract)}
                    disabled={!canSignContract() || agreeToEnterContract}
                  />
                  <p className="aon-checkbox-text">
                    I understand that by clicking ‘ACCEPT & PROCEED’, I am entering into a contract with Trojan Energy and the Initial Payment will be charged to my Registered Card
                  </p>
                </span>
                <br />
                {!signUpState.agreed_to_terms || !signUpState.initial_payment_submitted ? (
                  <>
                    {canSignContract() ? (
                      <span className="aon-buttons">
                        <AONButton
                          active={understandGrantClaim && agreeToPrivacyPolicy && agreeToEnterContract}
                          buttonText={!acceptAndProceed ? 'Accept & Proceed' : 'Please wait...'}
                          onClick={event => {
                            if (currentUser?.impersonating) return;
                            if (!acceptAndProceed) setAcceptAndProceed(true); // Debounce payment button
                          }}
                          disabled={currentUser?.impersonating}
                        />
                      </span>
                    ) :(
                      <span className="aon-buttons">
                        <AONButton
                          active={true}
                          buttonText={'Back to Dashboard'}
                          onClick={event => {
                            setStage('2_1_DASHBOARD');
                          }}
                          disabled={false}
                        />
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    <div className="aon-frame">
                      <span className="aon-text-box-span-bold">
                        You agreed to the Trojan Home Terms of Service on{' '}
                        {getSignatureDate(signUpState.agreed_to_terms)} at{' '}
                        {getSignatureTime(signUpState.agreed_to_terms)}.
                      </span>
                    </div>
                    {contractEndDate ? (
                      <>
                        <br />
                        This Contract was cancelled on{' '}
                        <b>{contractEndDate}</b>
                      </>
                    ) : (
                      ''
                    )}
                    <br />
                    <br />
                    <span className="aon-buttons">
                      <AONButton
                        active={true}
                        buttonText={'Back to Dashboard'}
                        onClick={event => {
                          setHostingType();
                          setStage('2_1_DASHBOARD');
                        }}
                      />
                    </span>
                  </>
                )}
              </div>
            </Segment>
          )}
          {stage === '4_1_PROCESSING_APPLICATION' && (
            <Segment>
              <div className="aon-modal">      
                <div className="aon-header">
                  <span className="aon-header-span-blue">Thank you!</span>{' '}
                  <span className="aon-header-span-green"></span>
                </div>
                <br />

                {initialPaymentJustPaid && getInitialPaymentPounds() > 0 ? (
                  <>
                    <div className="aon-frame">
                      <div className="aon-text-box">
                        <span className="aon-text-box-span-light">
                          Your Initial Payment of £{getInitialPaymentPounds()}{isTrojanTesting() ? <b> (£1 FOR THIS TEST)</b> : ''} has been submitted and will be processed within 24 hours.
                          <br />
                        </span>
                      </div>
                    </div>
                    <br />
                  </>
                ) : ''}
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span className="aon-text-box-span-light">
                      Your submission and survey will be reviewed by the Trojan team and we will respond to you within 10 working days. Installation usually takes 6-8 weeks from approval. Once approval has been received we will ask you to submit your payment details before we proceed with the installation.
                      <br />
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Back to Dashboard'}
                    onClick={event => {
                      setStage('2_1_DASHBOARD');
                    }}
                  />
                </span>
              </div>
            </Segment>
          )}
          {stage === '4_2_REJECTED' && (
            <Segment>
              <div className="aon-modal">
                <div className="aon-header">
                  <span className="aon-header-span-blue">Sorry.</span>{' '}
                  <span className="aon-header-span-green"></span>
                </div>
                <br />
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span>
                      <span className="aon-text-box-span-light">
                        Unfortunately, we are unable to offer Trojan Home to you at this time.
                      </span>
                    </span>
                  </div>
                </div>
                <br />
                <span className="aon-buttons">
                  <AONButton
                    active={true}
                    buttonText={'Exit.......'}
                    onClick={event => authAPI.logout()}
                  />
                </span>
              </div>
            </Segment>
          )}
        </Grid.Column>
      </Grid>
      <Modal open={confirmRequestSurveyOpen} size="small" style={{ padding: '20px' }}>
        <Modal.Content>
          <Header as="h2" textAlign="left">
            Request a survey
          </Header>
          Are you sure you want us to carry out a survey for you? You will save £25 if you do a self survey.
          <br />
          <br />
          <Button basic color="olive" onClick={() => {
            setAndSaveSignUpState({
              ...signUpState,
              self_survey: false
            });

            setConfirmRequestSurveyOpen(false);
            setStage('2_3_1_REQUESTED_TROJAN_SURVEY');
          }}>
            Yes
          </Button>
          <Button basic onClick={() => {
            setConfirmRequestSurveyOpen(false);
          }}>
            No
          </Button>
        </Modal.Content>
      </Modal>
    </Container>
  );
};
